// extracted by mini-css-extract-plugin
export default {"documentBundle":"SKUx0ZnfERXyzs4PovnP"};